import React from 'react';
import { Field, Form, Formik } from 'formik';
import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { email } from '../../../utils/validation';
import { FormikFieldRenderProps } from '@troy/shared/src/types/formik';

import {
  ActionButton,
  Translation,
  TextInput
} from '@troy/shared/src/components/common';

interface ForgotPasswordFormProps {
  onCancel: () => void;
  onSubmit: (values: { email: string }) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    marginTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  email: {
    width: '100%'
  },
  sendButton: {
    marginTop: theme.spacing(2),
    width: `calc(100% - ${theme.spacing(4)})`
  },
  cancelButton: {
    marginTop: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(4)})`
  }
}));

const EmailField: React.FC<FormikFieldRenderProps> = ({
  field: { name, value, onChange }
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <TextInput
      className={classes.email}
      id="page.forgot-password.component.email-form.forgot-password-email"
      placeholder="E-Mail"
      inputPlaceholder="ALL_UXCOPIES_PLACEHOLDER_EMAIL"
      startIcon="profile"
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onSubmit,
  onCancel
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <Formik validateOnMount onSubmit={onSubmit} initialValues={{ email: '' }}>
      {({ isValid }): JSX.Element => (
        <Form className={classes.form}>
          <Field name="email" component={EmailField} validate={email} />
          <ActionButton
            id="page.forgot-password.component.email-form.forgot-password-button"
            type="submit"
            className={classes.sendButton}
            padding="medium"
            disabled={!isValid}
          >
            <Translation isFragment>UNIC_LOGIN_BUTTON_SEND</Translation>
          </ActionButton>
          <ActionButton
            id="page.forgot-password.component.email-form.forgot-password-cancel"
            className={classes.cancelButton}
            padding="medium"
            variant="outlined"
            color="warningDark"
            onClick={onCancel}
          >
            <Translation isFragment>ALL_UXCOPIES_BTN_CANCEL</Translation>
          </ActionButton>
        </Form>
      )}
    </Formik>
  );
};

export default ForgotPasswordForm;
